import { render, staticRenderFns } from "./KpiCardsCoupons.vue?vue&type=template&id=7afd4bb7&lang=pug&"
import script from "./KpiCardsCoupons.vue?vue&type=script&lang=js&"
export * from "./KpiCardsCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports